import store from '@/store';
import { incomeUpdateRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
    const { values } = store.state.formData;
    const { appId, cifnumber, productType } = store.state;
    const companyName = getValueByFieldName(values, FIELD_NAMES.companyName);
    const companyNameSelfEmployed = getValueByFieldName(values, FIELD_NAMES.companyNameSelfEmployed);
    const designation = getValueByFieldName(values, FIELD_NAMES.designation);
    const companyAge = getValueByFieldName(values, FIELD_NAMES.companyAge);
    const doj = getValueByFieldName(values, FIELD_NAMES.workAmount);
    const fixedIncome = getValueByFieldName(values, FIELD_NAMES.fixedIncome);
    const variableIncome = getValueByFieldName(values, FIELD_NAMES.variableIncome);
    const employmentType = getValueByFieldName(values, FIELD_NAMES.employmentType);
    const loanTenor = getValueByFieldName(values, FIELD_NAMES.instalmentsAmount);
    let variableIncomeNew;
    if (variableIncome) {
        variableIncomeNew = variableIncome;
    } else {
        variableIncomeNew = 0;
    }

    if (productType === 'Personal_Loan') {
        return {
            "app-id": appId,
            "cif-number": cifnumber,
            "fixed-income": fixedIncome,
            "variable-income": '' + variableIncomeNew + '',
            "employer-name": employmentType === 'Salaried' ? companyName : companyNameSelfEmployed,
            "designation": designation,
            "doj": doj,
            "loan-tenor": loanTenor != "1" ? loanTenor + " years" : loanTenor + " year",
            "company-age": companyAge,
            "income-per-month": '' + fixedIncome + '',
            "salried_flag": employmentType === 'Salaried' ? 'Y' : 'N'
        };
    } else if (productType === 'Credit Card') {
        return {
            "app-id": appId,
            "cif-number": cifnumber,
            "fixed-income": '' + fixedIncome + '',
            "variable-income": '' + variableIncomeNew + '',
            "employer-name": employmentType === 'Salaried' ? companyName : companyNameSelfEmployed,
            "designation": designation,
            "doj": doj,
            "loan-tenor": '0',
            "company-age": companyAge,
            "income-per-month": '' + fixedIncome + '',
            "salried_flag": employmentType === 'Salaried' ? 'Y' : 'N'
        };
    }
};

export default {
    async incomeUpdate(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: incomeUpdateRepository.incomeUpdate,
            payload: getPayload(),
        });
    }
};